import React, {PropTypes} from 'react';
import config from 'config';
import AbstractEditForm from '../../../common/AbstractEditForm';
import ErrorContainer from '../../../form/ErrorContainer';
import FullDatePicker from '../../../form/FullDatePicker';
import Input from '../../../form/Input';
import RaisedButton from 'material-ui/RaisedButton';
import ImageUpload from '../../../form/ImageUpload';

import {Container, Row, Col} from 'react-grid-system'
// import Countries from '../../../form/Countries';
import RichEditor from '../../../form/RichEditor/index';

import InputCheckbox from '../../../form/InputCheckbox';

class StreamEdit extends AbstractEditForm {
  static propTypes = {
    ...AbstractEditForm.propTypes,
    fields: PropTypes.objectOf({
      title: PropTypes.object,
      // countries: PropTypes.object,
      description: PropTypes.object,
      startDate: PropTypes.object,
      endDate: PropTypes.object,
      status: PropTypes.object,
      statusType: PropTypes.object
    })
  };
  save = async (item, data) => {
    
    await super.save(item, data)
    this.props.onClose()
  }
  publish = () => {
    return this.props.handleSubmit(async (data) => {
      await this.props.publish(this.props.model, data);
    })(this.props.values);
  };

  onChangeStartTime = (data) => {
    let minDate = new Date(data.getTime());
    if (minDate < new Date().getTime()) {
      minDate = new Date(data.getTime() + 60000);
    } else {
      minDate = data;
    }

    const minTimeDifference = 10 * 60 * 1000;
    let {
      fields: {
        startDate,
        endDate
      }
    } = this.props;

    if (!endDate.value || (endDate.value.getTime() - minDate.getTime()) < 0) {
      let endDateValue = new Date(minDate.getTime() + minTimeDifference);
      endDate.onChange(endDateValue);
    }

    startDate.onChange(minDate);
  };

  _checkStartTime(startDate) {
    let {fields: {status, statusType}} = this.props;
    let now = new Date();
    if (startDate.value) {
      return now > startDate.value && status.value !== statusType.value.draft;
    }
  }

  render() {
    let {
      fields: {
        title,
        startDate,
        endDate,
        logo,
        status,
        vip_only,
        statusType,
        description,
        // countries
      },
      error,
      disabled,
      valid,
      submitting
    } = this.props;
    
    return (<form onSubmit={this.processSubmit} style={{padding: 27}}>
          {this._renderHeader()}
          <ErrorContainer error={error} touched={true}/>
          <Container style={{marginLeft: 0, padding: 0}}>
            <Row>
              <Col lg={8} md={10} xs={12}>
                <Row>
                  <Col xs={12}>
                    <ImageUpload
                      label="Stream Preview Picture"
                      required
                      imageWidth='auto'
                      imageHeight='300px'
                      disabled={disabled || this._checkStartTime(startDate)}
                      crop={config.streamCrop}
                      {...logo}
                    />
                  </Col>
                  <Col xs={12}>
                    <Input label="Add Stream Name" required
                          disabled={disabled || this._checkStartTime(startDate)} {...title}/>
                  </Col>
                  <Col xs={12}>
                    <FullDatePicker label="Add Start Time" required
                                    min={new Date()}
                                    disabled={disabled || this._checkStartTime(startDate)} {...startDate}
                                    onChange={this.onChangeStartTime}/>
                  </Col>
                  <Col xs={12}>
                    <FullDatePicker label="Add End Time" required
                                    disabled={disabled || this._checkStartTime(startDate)} {...endDate}/>
                  </Col>
                  <Col xs={12}>
                    <RichEditor label='Add Description Text' disabled={disabled || this._checkStartTime(startDate)} required {...description}/>
                  </Col>
                  <Col xs={12}>
                    <InputCheckbox
                      style={{cursor: 'pointer', marginBottom: 20}}
                      label={'VIP-only'}
                      {...vip_only}
                      disabled={disabled}
                      labelPosition='right'
                    />
                  </Col>
                </Row>
            <Row>
              <Col xs={6}>
              </Col>
                  <Col xs={6}>
                    <RaisedButton secondary={true}
                                  fullWidth={true}
                                  disabled={disabled || !valid || submitting}
                                  onClick={this.processSubmit}
                                  label="Save"/>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </form>
    );
  }
}

export default StreamEdit;





// WEBPACK FOOTER //
// ./src/components/Stream/LiveStream/StreamEditForm/StreamEditForm.js